<template>
  <van-dialog
    className="dialog"
    v-model="mShow"
    :showConfirmButton="false"
    :closeOnClickOverlay="true"
    @open="onShow"
  >
    <div class="content column">
      <div class="title">商品包</div>
      <van-icon class="close" name="cross" @click="close()" />
      <div class="grid-container">
        <div
          v-for="(item, index) in productList"
          :key="item.id"
          class="grid-item"
        >
          <div
            :class="[
              'item',
              'column',
              expandedIndex === index ? 'breathing' : '',
            ]"
          >
            <div class="item-top-bg colunm">
              <div class="itemTitle">
                {{
                  item.productType == 1
                    ? `${item.productNum}剪辑点`
                    : item.productType == 2
                    ? `${item.productNum}语音点`
                    : `${item.productNum}天会员`
                }}
              </div>
              <img
                class="itemImg"
                :src="
                  item.productType == 1
                    ? rewardPoint
                    : item.productType == 2
                    ? rewardVoice
                    : rewardVip
                "
                alt=""
              />
            </div>
            <div class="item-bottom-bg" @click="exchange(index, item)">
              {{ isExpand ? "膨胀" : "兑换" }}
            </div>
          </div>
        </div>
      </div>
      <div class="tips">活动到期后如未领取，商品包奖品自动清零</div>
    </div>
    <dialog-exchange
      ref="dialogExchange"
      @exchanged="exchangeOk"
    ></dialog-exchange>
    <dialog-get-award ref="dialogGetAward"></dialog-get-award>
    <dialog-expand-confim ref="dialogExpandConfim" @expanded="expanded">
    </dialog-expand-confim>
  </van-dialog>
</template>

<script>
import { Toast } from "vant";
import dialogExchange from "./dialogExchange.vue";
import dialogExpandConfim from "./dialogExpandConfim.vue";
import dialogGetAward from "./dialogGetAward.vue";

export default {
  components: { dialogExchange, dialogGetAward, dialogExpandConfim },

  data() {
    return {
      productList: [],
      mShow: false,
      isExpand: false,
      rewardPoint: require("../../assets/wheel/reward_point.png"),
      rewardVip: require("../../assets/wheel/reward_vip.png"),
      rewardVoice: require("../../assets/wheel/reward_voice.png"),
      expandedIndex: -1,
    };
  },

  mounted() {},
  methods: {
    onShow() {
      this.loadData();
    },

    loadData(showToast = true, breathIndex = -1) {
      this.$request.GET({
        url: "activity/first/pay/product/list",
        success: (obj) => {
          this.productList = obj;
          if (this.productList.length == 0) {
            if (showToast) {
              Toast({ message: "暂无商品" });
            }
          }
          this.$nextTick(() => {
            if (breathIndex > 0) {
              this.expandedIndex = breathIndex;
              setTimeout(() => {
                this.expandedIndex = -1;
              }, 1000);
            }
          });
        },
      });
    },

    expanded(index) {
      this.loadData(false, index);
      this.isExpand = false;
    },

    open(isExpand = false) {
      this.mShow = true;
      this.isExpand = isExpand;
    },

    exchange(index, item) {
      if (this.isExpand) {
        this.$refs.dialogExpandConfim.open(index, item);
      } else {
        this.$refs.dialogExchange.open(item);
      }
    },

    exchangeOk(item) {
      this.loadData(false);
      this.$refs.dialogGetAward.open(item.productType, item.productNum);
    },

    close() {
      this.mShow = false;
      this.$emit("close");

      // this.expandedIndex = 1;
      //   setTimeout(()=>{
      //     this.expandedIndex = -1;
      //   },1000)
    },
  },
};
</script>

<style scoped>
@import url(../../css/main.css);

.content {
  position: relative;
  height: 450px;
  background-image: url(../../assets/wheel/dialog_bg_big.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.title {
  margin-top: 16px;
  font-family: Source Han Sans SC;
  font-weight: 500;
  font-size: 26px;
  color: #000000;
  line-height: 30px;
}

.dialog {
  background: none !important;
}

.grid-container {
  height: 360px;
  overflow: scroll;
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px; /* 间距 */
}

.grid-item {
  width: 66px;
  height: 100px;
}
.item-top-bg {
  width: 100%;
  height: 80px;
  border-radius: 16px;
  background: linear-gradient(0deg, #12d6df 0%, #f70fff 100%);
}
.item-bottom-bg {
  margin-top: 5px;
  width: 50px;
  height: 16px;
  background: linear-gradient(96deg, #facc22 0%, #f83600 100%);
  border-radius: 16px;
  color: white;
  font-size: 10px;
  text-align: center;
  font-weight: 500;
}
.itemTitle {
  font-weight: 500;
  margin-top: 4px;
  color: white;
  font-size: 10px;
}
.itemImg {
  margin-top: 6px;
  width: 40px;
  object-fit: contain;
}

.close {
  position: absolute;
  right: 20px;
  top: 20px;
  font-weight: 500;
  font-size: 20px;
}
.tips {
  position: absolute;
  bottom: 10px;
  font-size: 10px;
  color: red;
}

.breathing {
  animation: breathe 1s ease-in-out 2; /* 使用 breathe 动画，持续时间为2秒，无限循环 */
}

@keyframes breathe {
  0%,
  100% {
    transform: scale(1); /* 在动画开始和结束时恢复到原始大小 */
  }
  50% {
    transform: scale(1.2); /* 在中间点放大到1.2倍 */
  }
}
</style>